<mat-form-field  class="dict-tag-file-manager">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
    <mat-option *ngIf="noneEntry" value="isNull">
      Brak
    </mat-option>

    <mat-option *ngFor="let item of items" [value]="item.uuid">
      {{item.name}}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
